function isFeatureAppDefinition(
// tslint:disable-next-line:no-any
maybeFeatureAppDefinition) {
    if (typeof maybeFeatureAppDefinition !== 'object' ||
        !maybeFeatureAppDefinition) {
        return false;
    }
    const featureAppDefinition = maybeFeatureAppDefinition;
    return typeof featureAppDefinition.create === 'function';
}
export function isFeatureAppModule(
// tslint:disable-next-line:no-any
maybeFeatureAppModule) {
    if (typeof maybeFeatureAppModule !== 'object' || !maybeFeatureAppModule) {
        return false;
    }
    return isFeatureAppDefinition(maybeFeatureAppModule.default);
}
//# sourceMappingURL=is-feature-app-module.js.map